import { addFollow } from '@eventbrite/follow-organizer-ebui';
import React, { useContext } from 'react';
import { ORGANIZER_PROFILE_PAGE_AREA } from '../../constants';
import { EnvContext, UserContext } from '../../context';
import { Organizer } from '../../types';
import { getLoginExperiment } from '../../utils/statsig';

interface FollowProviderProps {
    organizer: Organizer;
    userId: string;
    children: React.ReactNode;
}
interface FollowProviderWrapperProps {
    gaSettings: object;
    gaCategory: string;
    organizers: string[];
    isAuthenticated: boolean;
    loginOptions: object;
    userId: string;
    pageArea: string;
    children: React.ReactNode;
}

// addFollow is a HOC that wraps a component and provides follow context
// We pass a simple pass-through component that just renders children
const FollowProviderWithContext = addFollow(
    (props: FollowProviderWrapperProps) => <>{props.children}</>,
);

/**
 * Provides shared follow context for all FollowOrganizer components
 * within its children. This ensures all FollowOrganizer instances sync
 * their follow state.
 */
export const FollowProvider: React.FC<FollowProviderProps> = (props) => {
    const { isAuthenticated } = useContext(UserContext);
    const { gaSettings } = useContext(EnvContext);
    const loginOptions = {
        isLoginExperimentActive: getLoginExperiment(),
    };

    return (
        <FollowProviderWithContext
            isAuthenticated={isAuthenticated}
            gaSettings={gaSettings}
            gaCategory={'organizer'}
            organizers={[props.organizer.id]}
            loginOptions={loginOptions}
            userId={props.userId}
            pageArea={ORGANIZER_PROFILE_PAGE_AREA}
        >
            {props.children}
        </FollowProviderWithContext>
    );
};
